import { render, staticRenderFns } from "./addAuditInfo.vue?vue&type=template&id=d922d630&"
import script from "./addAuditInfo.vue?vue&type=script&lang=tsx&"
export * from "./addAuditInfo.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports